import { Button } from "@/components/ui/button";
import { useCustomParametersStore } from "../custom-parameters-store";
import { observer } from "mobx-react-lite";

export const Controls = observer(
  ({
    setIsOpen,
    setIsOpenConfirmDialog,
  }: {
    setIsOpen: (isOpen: boolean) => void;
    setIsOpenConfirmDialog: (isOpen: boolean) => void;
  }) => {
    const store = useCustomParametersStore();
    const { currentParameter, isEditingParameter, isViewing } = store;

    if (isViewing) {
      return (
        <Button
          className="w-full transition-all"
          onClick={() => setIsOpen(false)}
          variant="outline"
        >
          Close
        </Button>
      );
    }
    return (
      <>
        <Button
          className="w-full transition-all"
          variant="outline"
          onClick={() => {
            if (store.isStateDirty && store.isEditingParameter) {
              setIsOpenConfirmDialog(true);
              return;
            }

            if (store.hasPreviousState) {
              store.restorePreviousState();
            }

            setIsOpen(false);
          }}
          type="button"
        >
          Close
        </Button>
        <Button
          className="w-full transition-all"
          onClick={() => {
            if (!currentParameter) return;
            store.saveParameter(currentParameter);
            setIsOpen(false);
          }}
          disabled={!currentParameter}
          type="button"
        >
          {isEditingParameter ? "Update Parameter" : "Save Parameter"}
        </Button>
      </>
    );
  },
);
